<template>
  <Layout>
    <h1 class="font-semibold text-3xl text-gray-800">Prullenbak</h1>
    <div v-for="(models, type) in garbage" :key="type" class="my-6 max-w-2xl">
      <h2 class="font-semibold py-3">{{ type | typeTitle }}</h2>
      <div
        v-for="model in models"
        :key="type + model.id"
        class="bg-gray-100 rounded mb-1 py-2 px-3"
      >
        <div class="flex items-center">
          <div class="flex-1 truncate">
            <template v-if="type == 'contacts'">{{ model.name }}</template>
            <template v-else-if="type == 'people'">{{ model.firstname }} {{ model.lastname }}</template>
            <template v-else>{{ model.description }}</template>
          </div>
          <div
            class="mx-5 w-32 text-right flex-shrink-0 text-sm text-gray-500"
          >{{ model.deleted_at | formatTimeAgo }}</div>
          <button v-tooltip="'Terugzetten'" @click="restore(type, model)">
            <BaseIcon name="rotate-ccw" />
          </button>
        </div>
        <div v-if="model.contact" class="text-sm">
          <router-link
            :to="{ name: 'contacts.show', params: {id: model.contact.id }}"
          >{{ model.contact.name }}</router-link>
        </div>
      </div>
      <div v-if="models.length == 0" class="text-gray-400">Niets recent verwijderd</div>
    </div>
  </Layout>
</template>
      
<script>
import { get, destroy } from "@/api.js";

const TYPES = {
  contacts: "Dossiers",
  people: "Contactpersonen",
  deals: "Deals",
  notes: "Notities"
};

export default {
  metaInfo() {
    return { title: "Prullenbak" };
  },

  data() {
    return {
      garbage: {}
    };
  },

  beforeRouteEnter(to, from, next) {
    get(`/garbage`).then(response =>
      next(vm => {
        vm.garbage = response.data;
      })
    );
  },

  filters: {
    typeTitle(type) {
      return TYPES[type];
    }
  },

  methods: {
    restore(type, model) {
      destroy(`/garbage/${type}/${model.id}`).then(
        response => (this.garbage = response.data)
      );
    }
  }
};
</script>
      